<script lang="ts">
    import { Dropdown } from "carbon-components-svelte";
import { bind, onDestroy } from "svelte/internal";
import { writable } from 'svelte/store';

  /**
   * @typedef {string} DropdownItemId
   * @typedef {string} DropdownItemText
   * @typedef {{ id: DropdownItemId; text: DropdownItemText; }} DropdownItem
   * @event {{ selectedId: DropdownItemId, selectedIndex: number, selectedItem: DropdownItem }} select
   */

  let clazz: string | undefined | null = undefined;
  export {clazz as class}

  /**
   * Set the dropdown items
   * @type {DropdownItem[]}
   */
  export let items: any[] = [];

  /**
   * Override the display of a dropdown item
   * @type {(item: DropdownItem) => string}
   */
  export let itemToString = (item: any) => item.text || item.id || item.val;

  /** Specify the selected item index */
  export let selectedIndex = -1;

  /**
   * Specify the type of dropdown
   * @type {"default" | "inline"}
   */
  export let type: "default" | "inline" = "default";

  /**
   * Specify the direction of the dropdown menu
   * @type {"bottom" | "top"}
   */
  export let direction: "bottom" | "top" = "bottom";

  /**
   * Specify the size of the dropdown field
   * @type {"sm" | "lg" | "xl"}
   */
  export let size: any = undefined;

  /** Set to `true` to open the dropdown */
  export let open = false;

  /** Set to `true` to use the inline variant */
  export let inline = false;

  /** Set to `true` to enable the light variant */
  export let light = false;

  /** Set to `true` to disable the dropdown */
  export let disabled = false;

  /** Specify the title text */
  export let titleText = "";

  /** Set to `true` to indicate an invalid state */
  export let invalid = false;

  /** Specify the invalid state text */
  export let invalidText = "";

  /** Set to `true` to indicate an warning state */
  export let warn = false;

  /** Specify the warning state text */
  export let warnText = "";

  /** Specify the helper text */
  export let helperText = "";

  /**
   * Specify the list box label
   * @type {string}
   */
  export let label: string | undefined = undefined;

  /** Set to `true` to visually hide the label text */
  export let hideLabel = false;

  /**
   * Override the default translation ids
   * @type {(id: any) => string}
   */
  export let translateWithId: any = undefined;

  /** Set an id for the list box component */
  export let id = "ccs-" + Math.random().toString(36);

  /**
   * Specify a name attribute for the list box
   * @type {string}
   */
  export let name: string | undefined = undefined;

  /** Obtain a reference to the button HTML element */
  export let ref: any = null;

  export let selectedVal: any = undefined


  let valStore = writable<any>(selectedVal)
  $: valStore.set(selectedVal)

  onDestroy(valStore.subscribe((val) => {
    //console.log("Selected", val)
    selectedVal = val
    for (let i in items) {
      if (items[i].val == selectedVal) {
        selectedIndex = Number(i)
        break
      }
    }
  }))

  //$: console.log("SelIdx changed", selectedIndex)

  if (selectedVal != undefined) {
    for (let i in items) {
      if (items[i].val == selectedVal) {
        selectedIndex = Number(i)
        break
      }
    }
  }

  $: if (items[selectedIndex]) {
    let val = items[selectedIndex].val
    if (val != undefined) {
      selectedVal = val
    } else {
      selectedVal = items[selectedIndex].id
    }
  }

</script>

<Dropdown bind:selectedIndex={selectedIndex} bind:open={open} bind:inline={inline} 
bind:ref={ref} items={items} itemToString={itemToString} 
on:select
type={type}
direction={direction} size={size} light={light} disabled={disabled} titleText={titleText}
invalid={invalid} invalidText={invalidText} warn={warn} warnText={warnText}
helperText={helperText} label={label} hideLabel={hideLabel} translateWithId={translateWithId}
id={id} name={name} class={clazz}
/>


